import { NOTES } from "../actionTypes";


export const getNotes = () => {
    return { type: NOTES.GET_NOTES, payload: {} };
};

export const updateNotes = (objNewNotes) => {
    return { type: NOTES.UPDATE_NOTES, payload: objNewNotes };
};